import {settings} from './CompareBuildsPage.slices'

export const setShowChangedOnly = () => settings.actions.setShowChangedOnly(true)
export const setShowAll = () => settings.actions.setShowChangedOnly(false)
